import { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css";
import CommitteeHomePage from "./Pages/CommitteeHomePage";
import CommitteeDocumentPage from "./Pages/CommitteeDocumentPage";
import CommitteeEventPage from "./Pages/CommitteeEventPage";
import CommitteeMemberPage from "./Pages/CommitteeMemberPage";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { committeeActions } from "../../../_store/committee.slice";
import CommitteeAdditionalResource from "./Pages/CommitteeAdditionalResource";
import CommitteePostPage from "./Pages/CommitteePostPage";
import CommitteeCategoryPage from "./Pages/CommitteeCategoryPage";
import { homePageActions } from "../../../_store/home.slice";

function EditCommitteePageIntegrate() {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("homePage");
  const { commiteePageID } = useParams();

  useEffect(() => {
    dispatch(
      committeeActions?.getCommitteeHomePageIntegrationData(commiteePageID)
    );
    dispatch(homePageActions?.getTextEditorTemplate());
  }, []);

  const handleTabClick = (tabName, resetEventName) => {
    if (activeTab === tabName) {
      // 👇 fire reset event if same tab clicked again
      window.dispatchEvent(new Event(resetEventName));
    }
    setActiveTab(tabName);
  };

  return (
    <>
      <ul className="nav nav-pills mb-2">
        <li className="nav-item">
          <Link
            href="#"
            className={`nav-link ${activeTab === "homePage" ? "active" : ""}`}
            onClick={() => setActiveTab("homePage")}
          >
            <span className="d-sm-none">Home</span>
            <span className="d-sm-block d-none">Home</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            href="#"
            className={`nav-link ${
              activeTab === "documentPage" ? "active" : ""
            }`}
            // onClick={() => setActiveTab("documentPage")}
            onClick={() => handleTabClick("documentPage", "resetDocumentPage")}
          >
            <span className="d-sm-none">Document</span>
            <span className="d-sm-block d-none">Document</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            href="#"
            className={`nav-link ${
              activeTab === "calenderPage" ? "active" : ""
            }`}
            // onClick={() => setActiveTab("calenderPage")}
            onClick={() => handleTabClick("calenderPage", "resetCalendarPage")}
          >
            <span className="d-sm-none">Calendar</span>
            <span className="d-sm-block d-none">Calendar</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            href="#"
            className={`nav-link ${activeTab === "postsPage" ? "active" : ""}`}
            // onClick={() => setActiveTab("postsPage")}
            onClick={() => handleTabClick("postsPage", "resetPostsPage")}
          >
            <span className="d-sm-none">Posts</span>
            <span className="d-sm-block d-none">Posts</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            href="#"
            className={`nav-link ${activeTab === "memberPage" ? "active" : ""}`}
            // onClick={() => setActiveTab("memberPage")}
            onClick={() => handleTabClick("memberPage", "resetMemberPage")}
          >
            <span className="d-sm-none">Member</span>
            <span className="d-sm-block d-none">Member</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            href="#"
            className={`nav-link ${
              activeTab === "CommitteeCategoryPage" ? "active" : ""
            }`}
            // onClick={() => setActiveTab("CommitteeCategoryPage")}
            onClick={() =>
              handleTabClick(
                "CommitteeCategoryPage",
                "resetCommitteeCategoryPage"
              )
            }
          >
            <span className="d-sm-none">Documents Category</span>
            <span className="d-sm-block d-none">Documents Category</span>
          </Link>
        </li>
        {/* <li className="nav-item">
          <Link
            href="#"
            className={`nav-link ${activeTab === "additionalResource" ? "active" : ""
              }`}
            onClick={() => setActiveTab("additionalResource")}
          >
            <span className="d-sm-none">Pills 6</span>
            <span className="d-sm-block d-none">Additional Resource</span>
          </Link>
        </li> */}
      </ul>

      <div className="tab-content">
        {activeTab === "homePage" && (
          <div className="tab-pane fade show active">
            <CommitteeHomePage />
          </div>
        )}
        {activeTab === "documentPage" && (
          <div className="tab-pane fade show active">
            <CommitteeDocumentPage />
          </div>
        )}
        {activeTab === "calenderPage" && (
          <div className="tab-pane fade show active">
            <CommitteeEventPage />
          </div>
        )}
        {activeTab === "memberPage" && (
          <div className="tab-pane fade show active">
            <CommitteeMemberPage />
          </div>
        )}
        {activeTab === "additionalResource" && (
          <div className="tab-pane fade show active">
            <CommitteeAdditionalResource />
          </div>
        )}
        {activeTab === "postsPage" && (
          <div className="tab-pane fade show active">
            <CommitteePostPage />
          </div>
        )}
        {activeTab === "CommitteeCategoryPage" && (
          <div className="tab-pane fade show active">
            <CommitteeCategoryPage />
          </div>
        )}
      </div>
    </>
  );
}

export default EditCommitteePageIntegrate;
